import { render, staticRenderFns } from "./MultipleView.vue?vue&type=template&id=18c833d2&"
import script from "./MultipleView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MultipleView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports